import React, { CSSProperties } from "react";
import { useTranslation } from "react-i18next";
import { VelavuDevice } from "velavu-js-api";
import VelavuExpandMenu from "../../elements/velavu-expand-menu";
import VelavuSimpleTable from "../../elements/velavu-simple-table";
import { formatDateTime } from "../../helper/language-helper";

export default function TabTagEnvironment(props: {
	style?: CSSProperties;
	className?: string;
	tag: VelavuDevice;
}) {
	const { t } = useTranslation();

	if (!props.tag.environment) return null;

	return (
		<VelavuExpandMenu
			style={props.style}
			className={props.className}
			label={t("asset_detail.tag.environment")}
		>
			<VelavuSimpleTable>
				<tbody>
					{props.tag.environment?.temperature_c && (
						<tr>
							<td>{t("asset_detail.tag.temperature")}</td>
							<td>{props.tag.environment.temperature_c} °C</td>
						</tr>
					)}
					{props.tag.environment?.humidity && (
						<tr>
							<td>{t("asset_detail.tag.humidity")}</td>
							<td>{props.tag.environment.humidity}%</td>
						</tr>
					)}
					{props.tag.environment?.timestamp && (
						<tr>
							<td>{t("asset_detail.tag.last_updated")}</td>
							<td>
								{formatDateTime(
									props.tag.environment.timestamp,
								)}
							</td>
						</tr>
					)}
				</tbody>
			</VelavuSimpleTable>
		</VelavuExpandMenu>
	);
}
